//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'Spread',
    data(){
        return{
            article:["box1","box2"],
            currentimg:0,
            niceLogo0:require("../../../assets/detail/like_nor.png"),
            niceLogo1:require("../../../assets/detail/like_sel.png"),
            introduce: '',
            // 是否展示所有文本内容
            showTotal: true,
            // 显示展开还是收起
            exchangeButton: true,
            // 是否显示展开收起按钮
            showExchangeButton: false,
            rem: ''
        }
    },
      mounted () {
        this.init();
    },

     methods: {
       changeState(index){
         console.log(index)
            this.currentimg = index;
        },

            showTotalIntro () {
      console.log(this.showTotal);
      this.showTotal = !this.showTotal;
      this.exchangeButton = !this.exchangeButton;
    },
    getRem () {
      console.log('getRem');
      const defaultRem = 16;
      let winWidth = window.innerWidth;
      console.log('winWidth:' + winWidth);
      let rem = winWidth / 375 * defaultRem;
      return rem;
    },
    init () {
      this.introduce = '排查步骤：1、排查导出功能按钮中url地址是否有误；2、导出用的框架是框架封装的方法，导出的数据也是用框架封装的查询的数据，在该功能模块中查询用的是自定义的方法名为loadFirstItem的方法，导致框架的导出功能无法识别。2、导出用的框架是框架封装的方法，导出的数据也是用框架封装的查询的数据，在该功能模块中查询用的是自定义的方法名为loadFirstItem的方法，导致框架';
    },
     tryLong () {
      let longIntroduce = 'Vue是一套用于构建用户界面的渐进式框架。Vue 被设计为可以自底向上逐层应用。Vue 的核心库只关注视图层，不仅易于上手，还便于与第三方库或既有项目整合。另一方面，当与现代化的工具链以及各种支持类库结合使用时，Vue 也完全能够为复杂的单页应用提供驱动。Vue (读音 /vjuː/，类似于 view) 是一套用于构建用户界面的渐进式框架。与其它大型框架不同的是，Vue 被设计为可以自底向上逐层应用。Vue 的核心库只关注视图层，不仅易于上手，还便于与第三方库或既有项目整合。另一方面，当与现代化的工具链以及各种支持类库结合使用时，Vue 也完全能够为复杂的单页应用提供驱动。';
      if (this.introduce !== longIntroduce) {
        this.showExchangeButton = false;
        this.showTotal = true;
        this.introduce = longIntroduce;
      }
    }

    },

    watch: {
    'introduce': function () {
      this.$nextTick(function () {
        console.log('nextTick');
        // 判断介绍是否超过四行
        let rem = parseFloat(this.getRem());
        console.log('watch 中的rem', rem);
        if (!this.$refs.desc) {
          console.log('desc null');
          return;
        }
        let descHeight = window.getComputedStyle(this.$refs.desc).height.replace('px', '');
        console.log('descHeight:' + descHeight);
        console.log('如果 descHeight 超过' + (5.25 * rem) + '就要显示展开按钮');
        if (descHeight > 5.25 * rem) {
          console.log('超过了四行');
          // 显示展开收起按钮
          this.showExchangeButton = true;
          this.exchangeButton = true;
          // 不是显示所有
          this.showTotal = false;
        } else {
          // 不显示展开收起按钮
          this.showExchangeButton = false;
          // 没有超过四行就显示所有
          this.showTotal = true;
          console.log('showExchangeButton', this.showExchangeButton);
          console.log('showTotal', this.showTotal);
        }
        }.bind(this));
      }
    }
}



// WEBPACK FOOTER //
// ./src/views/sns/question/detail.vue